import {
  CONTACT_US_LOADING,
  CONTACT_US_SUCCESS,
  CONTACT_US_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { contactUsFormUrl } from "api/apiUrls";

export const contactUsActions =
  (data: any, userId?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: CONTACT_US_LOADING, payload: true });
      const response = await createNewItemService(
        `${contactUsFormUrl}${userId}/add`,
        data,
        "",
        "json"
      );

      dispatch({ type: CONTACT_US_SUCCESS, payload: response });

      if (response.status === 200) {
        notification.success({
          message: "Success",
        });
      } else {
        notification.error({
          message: "Something went wrong",
        });
      }
    } catch (err) {
      dispatch({ type: CONTACT_US_FAILURE, payload: err });
    } finally {
      dispatch({ type: CONTACT_US_LOADING, payload: false });
    }
  };
